/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Modifiedbyuserid3Inputs */

const en_entity_modifiedbyuserid3 = /** @type {(inputs: Entity_Modifiedbyuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified By User ID`)
};

const de_entity_modifiedbyuserid3 = /** @type {(inputs: Entity_Modifiedbyuserid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert von Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "Modified By User ID" |
*
* @param {Entity_Modifiedbyuserid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_modifiedbyuserid3 = /** @type {((inputs?: Entity_Modifiedbyuserid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Modifiedbyuserid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_modifiedbyuserid3(inputs)
	return de_entity_modifiedbyuserid3(inputs)
});
export { entity_modifiedbyuserid3 as "entity_modifiedByUserId" }